// extracted by mini-css-extract-plugin
module.exports = {"bookCardsList":"BookCardsList_bookCardsList__rfpkA","bookCardsList_mb":"BookCardsList_bookCardsList_mb__2TAL0"};